import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vehicules: [],
  searchterm: "",
  filteredData: [],
};

const vehiculeslice = createSlice({
  name: "vehicules",
  initialState,
  reducers: {
    setvehicules(state, action) {
      state.vehicules = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchterm = action.payload || "";
      state.filteredData = state.vehicules.filter(vehicule =>
        vehicule.plaque.toLowerCase().includes(state.searchterm.toLowerCase())
      );
      console.log("Filtered Data:", state.filteredData);
    },
  },
});

export const { setvehicules, setSearchTerm } = vehiculeslice.actions;
export default vehiculeslice.reducer;
